export default "__VITE_ASSET__M3SKPd2p__"